module.exports = __webpack_public_path__ + "static/media/02A.e9310111.png";